























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  hsabExpenseOriginatorTypeMap,
  HsabExpenseCategory,
  HsabExpenseResponse,
  WexClaimReceiptStatus,
  wexClaimReceiptStatusMap
} from "@/shared/types";
import moment from "moment";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { formatCurrency } from "@/shared/currency.js";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill
  }
})
export default class HsbExpenseCardRowExpenseDetail extends Vue {
  formatCurrency = formatCurrency;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  get formattedDateOfService () {
    return moment(this.expense.dateOfService).format("MMM DD, YYYY");
  }

  get formattedOriginator () {
    if (this.expense.originator) {
      return this.hsabExpenseOriginatorTypeMap[this.expense.originator];
    }
    return "Unknown";
  }

  get status (): WexClaimReceiptStatus {
    return this.expense.reimbursement ?
        this.expense.reimbursement.claimReceiptStatus :
        WexClaimReceiptStatus.None;
  }

  get statusDisplayText () {
    return wexClaimReceiptStatusMap[this.status];
  }

  get showCategory () {
    return this.expense.expenseCategory !== undefined
        && this.expense.expenseCategory !== null
        && this.expense.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showExpenseType () {
    return this.expense.expenseType !== undefined
        && this.expense.expenseType !== null
        && this.expense.expenseType !== "";
  }

  get showExpenseSubType () {
    return this.expense.expenseSubType !== undefined
        && this.expense.expenseSubType !== null
        && this.expense.expenseSubType !== "";
  }
}
